/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ subject: NonNullable<unknown> }} Rights_Tools_Remove_Subject_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "This removes every per-tool override for {subject}. They fall back to the everyone defaults." |
*
* @param {Rights_Tools_Remove_Subject_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_remove_subject_confirm_description = /** @type {((inputs: Rights_Tools_Remove_Subject_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Remove_Subject_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Entfernt alle tool-spezifischen Ausnahmen für ${i?.subject}. Es gelten wieder die „Alle“-Standards.`)
	return /** @type {LocalizedString} */ (`This removes every per-tool override for ${i?.subject}. They fall back to the everyone defaults.`)
});